import { PlusIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import { FC } from "react";

interface MergeSectionButtonProps {
  isDraggingOver: boolean;
  isDragging: boolean;
  onHoverChange?: (isHovered: boolean) => void;
  onMerge?: () => void;
}

export const MergeSectionButton: FC<MergeSectionButtonProps> = ({
  isDraggingOver,
  isDragging,
  onHoverChange,
  onMerge,
}) => (
  <div
    className="h-0 relative z-10 group top-[-6px]"
    onMouseEnter={() => onHoverChange?.(true)}
    onMouseLeave={() => onHoverChange?.(false)}
    onClick={onMerge}
  >
    <div
      className={clsx(
        `absolute left-0 right-0 top-0 flex items-center justify-center opacity-0 transition-opacity cursor-pointer`,
        !isDraggingOver && !isDragging
          ? "group-hover:opacity-100"
          : "group-hover:opacity-0"
      )}
    >
      <div className="bg-blue-100 dark:bg-blue-900 h-[2px] rounded-[30px] w-[calc(50%-10px)]" />
      <PlusIcon className="w-3 h-3 text-blue-400 stroke-blue-400 rounded-full bg-background" />
      <div className="bg-blue-100 dark:bg-blue-900 h-[2px] rounded-[30px] w-[calc(50%-10px)]" />
    </div>
  </div>
);
